// src/utils/notice.js
import Vue from 'vue';

/**
 * 自定义通知封装
 * @param {String} type 类型：success/error/warning
 * @param {String} title 标题
 * @param {String} desc 描述
 * @param {Object} options 额外配置（如 duration）
 */
const customNotice = (type, title, desc, options = {}) => {
    // 定义图标类型映射
    const iconTypes = {
        success: 'md-checkmark-circle',
        error: 'md-warning',
        warning: 'md-warning'
    };

    // 定义样式类名映射
    const classNames = {
        success: 'custom-notice-success',
        error: 'md-warning',
        warning: 'custom-notice-warning'
    };

    // 基础配置
    const baseConfig = {
        title,
        desc,
        duration: 4, // 默认4秒
        className: classNames[type],
        render(h) {
            return h('div', [
                h('Icon', {
                    props: { type: iconTypes[type] },
                    class: 'ivu-notice-icon'
                }),
                h('span', { class: 'ivu-notice-title' }, this.title),
                // h('p', { class: 'ivu-notice-desc' }, this.desc)
            ])
        },
        ...options // 合并用户自定义配置
    };

    // 调用对应类型的通知
    Vue.prototype.$Notice[type](baseConfig);
};

// 快捷方法导出
export const notice = {
    success: (title, desc, options) => customNotice('success', title, desc, options),
    error: (title, desc, options) => customNotice('error', title, desc, options),
    warning: (title, desc, options) => customNotice('warning', title, desc, options)
};